// eslint-disable-next-line consistent-default-export-name/default-import-match-filename
import ValueCell from './server/ValueCell'
import WithResize from './WithResize'
import styles from './server/elements/Table.module.css'
import { memo } from 'react'
import { useDataColumnValue, useField } from './utils/TableStore'
import type { ColumnField } from './server/types'
const ValueCellWithResize = WithResize(ValueCell)

function DataCell<T extends Record<string, unknown>, K extends ColumnField<T> = ColumnField<T>>({
  field,
  dataId,
  firstRow,
  colIndex,
}: {
  field: K
  dataId: string
  firstRow: boolean
  colIndex: number
}) {
  const value = useDataColumnValue<T, K>(field, dataId)
  const res = useField(field)
  const render = res?.render
  return (
    <ValueCellWithResize
      render={render}
      value={value}
      className={firstRow ? styles.headerCell : undefined}
      colIndex={colIndex}
      firstRow={firstRow}
    />
  )
}

export default memo(DataCell)
